import store from '@/store'
import { config } from '../plugins/env.config';

const ChangePassword = () => import('@/components/change-password/ChangePassword');
const ForgotPassword = () => import('@/components/forgot-password/ForgotPassword');
const Home = () => import('@/components/home/Home');
const HomeLayout = () => import('@/components/home-layout/HomeLayout');
const Login = () => import('@/components/login/Login');
const TermsAndConditions = () => import('@/components/terms-and-conditions/TermsAndConditions');
const UpdatePassword = () => import('@/components/update-password/UpdatePassword');
const SettlementsLayout = () => import('@/components/settlements/SettlementsLayout')
const SettlementsList = () => import('@/components/settlements/settlements-list/SettlementsList')
const CreateSettlementLayout = () => import('@/components/settlements/create-settlement/CreateSettlementLayout');
const SettlementDetail = () => import('@/components/settlements/settlement-detail/SettlementDetail');
const AuthorizationDetail = () => import('@/components/authorization/detail/AuthorizationDetail');

const AuthorizationLayout = () => import('@/components/authorization/new/AuthorizationLayout');
const AuthorizationTypes = () => import('@/components/authorization/new/types/AuthorizationTypes');
const PrescriptionForm = () => import('@/components/authorization/new/forms/prescription/PrescriptionForm.vue');
const OutPatientCareForm = () => import('@/components/authorization/new/forms/outpatient-care/OutpatientCareForm');
const LaboratoriesForm = () => import('@/components/authorization/new/forms/laboratories/LaboratoriesForm.vue');
const DiagnosticStudyForm = () => import('@/components/authorization/new/forms/diagnostic-study/DiagnosticStudyForm.vue');
const MedicalProceduresForm = () => import('@/components/authorization/new/forms/medical-procedures/MedicalProceduresForm.vue');

const RcmLayout = () => import('@/components/rcm/RcmLayout');
const RcmHome = () => import('@/components/rcm/RcmHome');
const RcmAccountDetailLayout = () => import('@/components/rcm/detail/RcmAccountDetailLayout');
const SupportsAdministratorLayout = () => import('@/components/rcm/supports-administrator/SupportsAdministratorLayout');
const RcmChargeDetailLayout = () => import('@/components/rcm/charge-detail/RcmChargeDetailLayout');
const AgreementsLayout = () => import('@/components/rcm/agreements/AgreementsLayout');
const AgreementDetailLayout = () => import('@/components/rcm/agreements/AgreementDetailLayout');
const AuditRuleDetail = () => import('@/components/rcm/agreements/audit-rules/AuditRuleDetail')
const SupportsConfiguration = () => import('@/components/rcm/agreements/supports-configuration/SupportsConfiguration')
const PreSettlementsLayout = () => import('@/components/rcm/pre-settlements/PreSettlementsLayout')
const PreSettlementsDetail = () => import('@/components/rcm/pre-settlements/PreSettlementsDetail')
const ProductsConfiguration = () => import('@/components/rcm/products-configuration/ProductsConfiguration')
const ProductsDetailConfiguration = () => import('@/components/rcm/products-configuration/ProductsDetailConfiguration')
const EditPackageConfiguration = () => import('@/components/rcm/agreements/package-configuration/edit/EditPackageConfiguration')
const PreSettlementPackageConfiguration = () => import('@/components/rcm/pre-settlements/PreSettlementPackageConfiguration')
const UploadAgreementMatrix = () => import('@/components/rcm/upload-agreement-matrix/UploadAgreementMatrix.vue')
const EmailNotification = () => import('@/components/tfa/EmailNotification')
const EmailVerification = () => import('@/components/tfa/EmailVerification')
const SmsVerification = () => import('@/components/tfa/SmsVerification')

const v2Layout = () => import('@/components/v2/v2Layout');
const v2Home = () => import('@/components/v2/v2Home');
const SponsorTemplates = () => import('@/components/v2/sponsor-templates/SponsorTemplates');
const v2DetailAuthorization = () => import('@/components/v2/detail/v2DetailAuthorizationLayout.vue');
const AddAuthorizationLayout = () => import('@/components/v2/new/add-authorization/AddAuthorizationLayout');


const areUserPrerequisitesValid = (to, from, next) => {

  if (!store.getters.isAuthenticated) {
    return next('/login')
  }

  if (store.getters.passwordRotationRequired && !store.getters.passwordRotationUpdated) {
    return next('/change-password-required')
  }

  if (store.getters.isTermsAndConditionsAcceptanceRequired) {
    return next('/terms-and-conditions')
  }

  if (store.getters.isRcmUser && !to.path.startsWith('/update-password')) {
    return next('/rcm')
  }

  if (store.getters.isUserWithoutClaims && !to.path.startsWith('/update-password')) {
    return next('/v2')
  }

  return next()
}

const prerequisiteValidated = (to, from, next) => {

  if (!store.getters.isAuthenticated) { return next('/login') }

  if (to.name === 'ChangePasswordRequired') {
    if (!store.getters.passwordRotationRequired || store.getters.passwordRotationRequired && store.getters.passwordRotationUpdated) {
      return next('/home')
    }

  } else if (to.name === 'TermsAndConditions') {

    if (!store.getters.isTermsAndConditionsAcceptanceRequired) {
      return next('/home')
    }

  }

  return next()
}

const areUserPrerequisitesValidRcm = (to, from, next) => {

  if (!store.getters.isAuthenticated) {
    return next('/login')
  }

  if (store.getters.passwordRotationRequired && !store.getters.passwordRotationUpdated) {
    return next('/change-password-required')
  }

  if (store.getters.isTermsAndConditionsAcceptanceRequired) {
    return next('/terms-and-conditions')
  }

  if (!store.getters.isRcmUser) {
    return next('/');
  }

  return next()
}

const areUserPrerequisitesValidV2Flow = (to, from, next) => {

  if (!store.getters.isAuthenticated) {
    return next('/login')
  }

  if (store.getters.passwordRotationRequired && !store.getters.passwordRotationUpdated) {
    return next('/change-password-required')
  }

  if (store.getters.isTermsAndConditionsAcceptanceRequired) {
    return next('/terms-and-conditions')
  }

  if (!store.getters.isUserWithoutClaims) {
    return next('/');
  }

  return next()
}

const areUserPrerequisitesValidSettlements = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    return next('/login')
  }

  if (store.getters.passwordRotationRequired && !store.getters.passwordRotationUpdated) {
    return next('/change-password-required')
  }

  if (store.getters.isTermsAndConditionsAcceptanceRequired) {
    return next('/terms-and-conditions')
  }

  if (config.showSettlementSection === 'false') {
    return next('/home')
  }

  return next()
}

const requireTfa = (to, from, next) => {
  if(!store.getters.isAuthenticated && store.getters.requiresTwoFactorAuthentication){
    return next()
  }
  next('/login')
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    component: HomeLayout,
    beforeEnter: areUserPrerequisitesValid,
    redirect: { name: 'Home' },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        beforeEnter: areUserPrerequisitesValid
      },
      {
        path: '/update-password',
        name: 'UpdatePassword',
        component: UpdatePassword,
        beforeEnter: areUserPrerequisitesValid
      },
      {
        path: '/authorizations/:authorizationId',
        name: 'AuthorizationDetail',
        component: AuthorizationDetail,
        beforeEnter: areUserPrerequisitesValid
      },
    ]
  },
  {
    path: '/change-password-required',
    name: 'ChangePasswordRequired',
    component: UpdatePassword,
    beforeEnter: prerequisiteValidated,
    props: { rotationRequiredFlow: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    props: (route) => ({ token: route.query.token }),
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
    beforeEnter: prerequisiteValidated
  },
  {
    path: '/email-notification',
    name: 'EmailNotification',
    component: EmailNotification,
    beforeEnter: requireTfa
  },
  {
    path: '/tfa-email-verification',
    name: 'EmailVerification',
    component: EmailVerification,
  },
  {
    path: '/tfa-sms-verification',
    name: 'SmsVerification',
    component: SmsVerification,
    beforeEnter: requireTfa
  },
  {
    path: '/authorization',
    component: AuthorizationLayout,
    beforeEnter: areUserPrerequisitesValid,
    children: [
      {
        path: 'new',
        name: 'AuthorizationTypes',
        component: AuthorizationTypes,
        beforeEnter: areUserPrerequisitesValid,
      },
      {
        path: 'outpatient-care',
        name: 'OutpatientCareForm',
        component: OutPatientCareForm,
        beforeEnter: areUserPrerequisitesValid,
      },
      {
        path: 'prescription',
        name: 'PrescriptionForm',
        component: PrescriptionForm,
        beforeEnter: areUserPrerequisitesValid,
      },
      {
        path: 'laboratories',
        name: 'LaboratoriesForm',
        component: LaboratoriesForm,
        beforeEnter: areUserPrerequisitesValid,
      },
      {
        path: 'diagnostic-study',
        name: 'DiagnosticStudyForm',
        component: DiagnosticStudyForm,
        beforeEnter: areUserPrerequisitesValid,
      },
      {
        path: 'procedure',
        name: 'MedicalProceduresForm',
        component: MedicalProceduresForm,
        beforeEnter: areUserPrerequisitesValid,
      },
      {
        path: '*',
        redirect: { name: 'Home' }
      }
    ]
  },
  {
    path: '/settlements',
    name: 'SettlementsLayout',
    component: SettlementsLayout,
    beforeEnter: areUserPrerequisitesValidSettlements,
    redirect: { name: 'SettlementsList' },
    children: [
      {
        path: '/',
        name: 'SettlementsList',
        component: SettlementsList,
        beforeEnter: areUserPrerequisitesValidSettlements,
      },
      {
        path: 'new',
        name: 'CreateSettlement',
        component: CreateSettlementLayout,
        beforeEnter: areUserPrerequisitesValidSettlements,
      },
      {
        path: ':settlementId',
        name: 'SettlementDetail',
        component: SettlementDetail,
        beforeEnter: areUserPrerequisitesValidSettlements,
      },
      {
        path: '*',
        redirect: { name: 'Home' }
      }
    ]
  },
  {
    path: '/rcm',
    name: 'RcmLayout',
    component: RcmLayout,
    beforeEnter: areUserPrerequisitesValidRcm,
    redirect: { name: 'RcmHome' },
    children: [
      {
        path: 'home',
        name: 'RcmHome',
        component: RcmHome,
        beforeEnter: areUserPrerequisitesValidRcm
      },
      {
        path: 'account/:accountId',
        name: 'RcmAccountDetailLayout',
        component: RcmAccountDetailLayout,
        beforeEnter: areUserPrerequisitesValidRcm
      },
      {
        path: 'charge/:chargeId',
        name: 'RcmChargeDetailLayout',
        component: RcmChargeDetailLayout,
        beforeEnter: areUserPrerequisitesValidRcm
      },
      {
        path: 'support-administrator/:accountId',
        name: 'RcmSupportAdministrator',
        component: SupportsAdministratorLayout,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'agreements',
        name: 'Agreements',
        component: AgreementsLayout,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'agreements/configuration',
        name: 'AgreementConfiguration',
        component: AgreementDetailLayout,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'agreements/configuration/packages',
        name: 'EditPackageConfiguration',
        component: EditPackageConfiguration,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'agreements/audit-rule',
        name: 'AuditRuleDetail',
        component: AuditRuleDetail,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'agreements/supports-configuration',
        name: 'SupportsConfiguration',
        component: SupportsConfiguration,
        beforeEnter: areUserPrerequisitesValidRcm
      },
      {
        path: 'pre-settlements',
        name: 'PreSettlements',
        component: PreSettlementsLayout,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'pre-settlements/package-configuration',
        name: 'PreSettlementPackageConfiguration',
        component: PreSettlementPackageConfiguration,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'pre-settlements/:originInvoiceGroupId',
        name: 'PreSettlementsDetail',
        component: PreSettlementsDetail,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'products-configuration',
        name: 'ProductsConfiguration',
        component: ProductsConfiguration,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'products-configuration/detail',
        name: 'ProductsDetailConfiguration',
        component: ProductsDetailConfiguration,
        beforeEnter: areUserPrerequisitesValidRcm,
      },
      {
        path: 'upload-agreement-matrix',
        name: 'UploadAgreementMatrix',
        component: UploadAgreementMatrix,
        beforeEnter: areUserPrerequisitesValidRcm,
      }
    ]
  },
  {
    path: '/v2',
    name: 'v2Layout',
    component: v2Layout,
    beforeEnter: areUserPrerequisitesValidV2Flow,
    redirect: { name: 'v2Home' },
    children: [
      {
        path: 'home',
        name: 'v2Home',
        component: v2Home,
        beforeEnter: areUserPrerequisitesValidV2Flow
      },
      {
        path: 'sponsor-templates',
        name: 'sponsorTemplates',
        component: SponsorTemplates,
        beforeEnter: areUserPrerequisitesValidV2Flow
      },
      {
        path: 'authorizations/:sponsorSlug/:authorizationCode',
        name: 'v2DetailAuthorization',
        component: v2DetailAuthorization,
        beforeEnter: areUserPrerequisitesValidV2Flow
      },
      {
        path: 'authorizations/:authorizationCode/new/:sponsorSlug/:authorizationFormSlug',
        name: 'v2NewAuthorization',
        component: AddAuthorizationLayout,
        beforeEnter: areUserPrerequisitesValidV2Flow
      }
    ]
  },
  {
    path: '*',
    redirect: { name: 'Home' }
  },
]

export default routes;
